function formMultimedia() {
	$(".formMultimedia__control--image").removeClass("active");
	$(".formMultimedia__control--video").removeClass("active");

	$(document).on("click", ".formMultimedia__control--image", function() {
		$(this).toggleClass("active");
		$(this)
			.parents(".formMultimedia__textareaWrapper")
			.siblings(".formMultimedia__imageWrapper")
			.toggleClass("active");
	});
	$(document).on("click", ".formMultimedia__control--video", function() {
		$(this).toggleClass("active");
		$(this)
			.parents(".formMultimedia__textareaWrapper")
			.siblings(".formMultimedia__videoAndSubmitWrapper")
			.find(".formMultimedia__videoIframe")
			.toggleClass("active");
	});
	$(document).on("click", ".formMultimedia__comment", function() {
		$(this)
			.parents(".formMultimedia")
			.addClass("active");
		if (
			$(this)
				.parents(".formMultimedia")
				.hasClass("formMultimedia--addPost")
		) {
			$("body").addClass("shaded");
		}
	});
	$(document).on("click", ".formMultimedia__cancel", function() {
		$(this)
			.parents(".formMultimedia")
			.removeClass("active");
		if (
			$(this)
				.parents(".formMultimedia")
				.hasClass("formMultimedia--addPost")
		) {
			$("body").removeClass("shaded");
		} else if (
			$(this)
				.parents(".accountFeedComment")
				.hasClass("is-show-editComment")
		) {
			$(".accountFeedComment").removeClass("is-show-editComment");
		}
	});
}

// function formMultimediaClose(e) {
// 	var formTarget = $(".formMultimedia");
// 	if (!formTarget.is(e.target) && formTarget.has(e.target).length === 0) {
// 		formTarget.removeClass("active");
// 		$("body").removeClass("shaded");
// 		e.stopPropagation();
// 	}
// }

function formMultimediaClose(e) {
	var formTarget = $(".formMultimedia");
	var dzInput = $(".dz-hidden-input");
	if (!formTarget.is(e.target) && formTarget.has(e.target).length === 0) {
		if (!dzInput.is(e.target) && dzInput.has(e.target).length === 0) {
			formTarget.removeClass("active");
			$("body").removeClass("shaded");
			e.stopPropagation();
		}
	}
}